module.exports = __webpack_public_path__ + "img/base.e6c159e6.png";